import Band from "@/views/Bands/model"
import Instrument from "@/views/Instruments/model"
import Person from "@/views/People/model"
import PersonCategory from "@/views/PersonCategories/model"
import PersonRole from "@/views/PersonRoles/model"
import Place from "@/views/Places/model"
import Show from "@/views/Shows/model"
import TransportCompany from "@/views/TransportCompanies/model"
import Hotel from "@/views/Hotels/model"
import Room from "@/views/Rooms/model"

const Concert = {
  verboseName: "Programma",
  verboseNamePlural: "Programmi",
  modelName: "Concert",
  modelNamePlural: "Concerts",
  appName: "concerts",
  propName: "concert",
  propNamePlural: "concerts",
}

const ConcertCategory = {
  verboseName: "Percorso",
  verboseNamePlural: "Percorsi",
  modelName: "ConcertCategory",
  modelNamePlural: "ConcertCategories",
  appName: "concerts",
  propName: "concertCategory",
  propNamePlural: "concertCategories",
}

const Event = {
  verboseName: "Evento",
  verboseNamePlural: "Eventi",
  modelName: "Event",
  modelNamePlural: "Events",
  appName: "events",
  propName: "event",
  propNamePlural: "events",
}

const Transport = {
  verboseName: "Trasporto",
  verboseNamePlural: "Trasporti",
  modelName: "Transport",
  modelNamePlural: "Transports",
  appName: "transports",
  propName: "transport",
  propNamePlural: "transports",
}

const Voucher = {
  verboseName: "Buono Pasto",
  verboseNamePlural: "Buoni Pasto",
  modelName: "Voucher",
  modelNamePlural: "Vouchers",
  appName: "vouchers",
  propName: "voucher",
  propNamePlural: "vouchers",
}

const ShowPerson = {
  verboseName: "Persona manifestazione",
  verboseNamePlural: "Persone manifestazione",
  modelName: "ShowPerson",
  modelNamePlural: "ShowPeople",
  appName: "shows",
  propName: "showPerson",
  propNamePlural: "showPeople",
}

const ShowPersonOptions = {
  verboseName: "Opzioni persona",
  verboseNamePlural: "Opzioni persona",
  modelName: "ShowPersonOptions",
  modelNamePlural: "ShowPersonOptions",
  appName: "shows",
  propName: "showPersonOptions",
  propNamePlural: "showPersonOptions",
}

const ShowInstrument = {
  verboseName: "Strumento manifestazione",
  verboseNamePlural: "Strumenti manifestazione",
  modelName: "ShowInstrument",
  modelNamePlural: "ShowInstruments",
  appName: "shows",
  propName: "showInstrument",
  propNamePlural: "showInstruments",
}

const ShowPlace = {
  verboseName: "Luogo manifestazione",
  verboseNamePlural: "Luoghi manifestazione",
  modelName: "ShowPlace",
  modelNamePlural: "ShowPlaces",
  appName: "shows",
  propName: "showPlace",
  propNamePlural: "showPlaces",
}

const ShowBand = {
  verboseName: "Gruppo manifestazione",
  verboseNamePlural: "Gruppi manifestazione",
  modelName: "ShowBand",
  modelNamePlural: "ShowBands",
  appName: "shows",
  propName: "showBand",
  propNamePlural: "showBands",
}

const ShowHotel = {
  verboseName: "Hotel manifestazione",
  verboseNamePlural: "Hotel manifestazione",
  modelName: "ShowHotel",
  modelNamePlural: "ShowHotels",
  appName: "shows",
  propName: "showHotel",
  propNamePlural: "showHotels",
}

const ShowRoom = {
  verboseName: "Stanza manifestazione",
  verboseNamePlural: "Stanze manifestazione",
  modelName: "ShowRoom",
  modelNamePlural: "ShowRooms",
  appName: "shows",
  propName: "showRoom",
  propNamePlural: "showRooms",
}

const Booking = {
  verboseName: "Prenotazione",
  verboseNamePlural: "Prenotazioni",
  modelName: "Booking",
  modelNamePlural: "Bookings",
  appName: "bookings",
  propName: "booking",
  propNamePlural: "bookings",
}

export default {
  Band,
  ConcertCategory,
  Concert,
  Event,
  Booking,
  Instrument,
  Person,
  PersonCategory,
  PersonRole,
  Place,
  Show,
  ShowBand,
  ShowInstrument,
  ShowPerson,
  ShowPersonOptions,
  ShowPlace,
  ShowHotel,
  ShowRoom,
  TransportCompany,
  Transport,
  Hotel,
  Room,
  Voucher,
}
